import { imageStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsImage";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

imageStyles.container = {
    ...imageStyles.container,
    css: css`
        margin: 20px 0 0;
        justify-content: center;
        display: flex;

        ${mediaQueriesBP.maxMD} {
            justify-content: center;
            display: flex;

            & > div {
                max-width: 320px;
            }
        }
    `,
};

imageStyles.imageItem = {
    ...imageStyles.imageItem,
    css: css`
        justify-content: center;
    `,
};

imageStyles.productLinkItem = {
    ...imageStyles.productLinkItem,
    css: css`
        padding-bottom: 0;
        justify-content: center;
        text-align: center;
    `,
};
